import { useKeycloak } from "@react-keycloak/web";
import React, { createContext, useContext, useState, useRef } from "react";
import useLandingAuthApi from "./api/useLandingAuthApi";

const LogoutContext = createContext({
  isSessionExpired: false,
  handleLogout: () => {},
  handleSessionExpired: () => {},
  handleSessionExpiredConfirm: () => {},
  logout: () => {},
});

export const useLogout = () => {
  const context = useContext(LogoutContext);
  if (context === undefined) {
    throw new Error("useLogout must be used within a LogoutProvider");
  }

  return context;
};

export const LogoutProvider = ({ children }) => {
  const { keycloak } = useKeycloak();
  const { removeDeviceToken } = useLandingAuthApi();
  const [isSessionExpired, setIsSessionExpired] = useState(false);
  const isHandlingSessionExpired = useRef(false);

  const logout = () => {
    keycloak.logout();
  };

  const handleLogout = async () => {
    try {
      const permission = await Notification.requestPermission();
      if (permission === "granted") {
        await removeDeviceToken();
      }
    } catch (error) {
      console.error("Error removing device token:", error);
    }
    setIsSessionExpired(false);
    logout();
  };

  const handleSessionExpired = () => {
    if (!isHandlingSessionExpired.current) {
      isHandlingSessionExpired.current = true;
      setIsSessionExpired(true);
    }
  };

  const handleSessionExpiredConfirm = () => {
    isHandlingSessionExpired.current = false;
    setIsSessionExpired(false);
    keycloak.logout();
  };

  const value = {
    isSessionExpired,
    handleLogout,
    handleSessionExpired,
    handleSessionExpiredConfirm,
    logout,
  };

  return (
    <LogoutContext.Provider value={value}>{children}</LogoutContext.Provider>
  );
};
